import { withSpinner, success } from "../../../../redux/actions/utilities";
import {
  processedMarketingAttributionReduxConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { processedMarketingAttributionReportServices } from "../../services";

const {
  GET_PROCESSED_MARKETING_ATTRIBUTION_GRAPH_DATA,
  GET_PROCESSED_MARKETING_ATTRIBUTION_PAGINATED_DATA,
} = processedMarketingAttributionReduxConstants;

const getProcessedMarketingAttributionReportPaginatedData = (body) => {
  return (dispatch) => {
    withSpinner(
      dispatch,
      GET_PROCESSED_MARKETING_ATTRIBUTION_PAGINATED_DATA,
      () =>
        processedMarketingAttributionReportServices
          .getProcessedMarketingAttributionReportPaginatedData(body)
          .then(
            (response) => {
              dispatch(
                success(
                  response,
                  GET_PROCESSED_MARKETING_ATTRIBUTION_PAGINATED_DATA
                )
              );
            },
            (error) => {
              customToast(error[0], toastTypes.ERROR);
            }
          )
    );
  };
};

const getProcessedMarketingAttributionReportGraphData = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_PROCESSED_MARKETING_ATTRIBUTION_GRAPH_DATA, () =>
      processedMarketingAttributionReportServices
        .getProcessedMarketingAttributionReportGraphData(body)
        .then(
          (response) => {
            dispatch(
              success(response, GET_PROCESSED_MARKETING_ATTRIBUTION_GRAPH_DATA)
            );
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const processedMarketingAttributionReportActions = {
  getProcessedMarketingAttributionReportGraphData,
  getProcessedMarketingAttributionReportPaginatedData,
};
